import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

import { Case } from '../../../../shared/api/hscan/case';
import { ImageView } from '../../common/components/ImageView';
import { Spacer } from '../../common/components/Spacer';
import {
  SectionContentContainer,
  SectionHeading,
} from '../../common/components/styledComponents';

import { ImageDetailButtons } from './ImageDetailButtons';
import { ImageInfoTable } from './ImageInfoTable';
import { PatientInfoTable } from './PatientInfoTable';

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 25px;
`;

const TableWapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 17px;
  overflow-x: auto;
`;

const DetailsWrapper = styled.div`
  display: flex;
  width: 100%;
`;

interface ImageDetailsProps {
  caseInfo: Case;
}
export const ImageDetails = (props: ImageDetailsProps) => {
  const { caseInfo } = props;
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.imageList.imageDetails',
  });

  const imageId = caseInfo?.contentIds?.length ? caseInfo.contentIds[0] : '';
  return (
    <SectionContentContainer>
      <SectionHeading>{t('heading')}</SectionHeading>
      <Spacer height="39px" />
      <DetailsWrapper>
        <ImageWrapper>
          <ImageView imageId={imageId} width="320px" />
          <ImageDetailButtons caseInfo={caseInfo} />
        </ImageWrapper>
        <TableWapper>
          <PatientInfoTable caseInfo={caseInfo} />
          <ImageInfoTable caseInfo={caseInfo} />
        </TableWapper>
      </DetailsWrapper>
    </SectionContentContainer>
  );
};
